module.exports = __webpack_public_path__ + "img/tengxunshipin.6b71c2eb.png";